import CONFIG from '../config'
import { SessionData } from '../types/interface/session.interface'

export const setItem = (token: string, kid: string): void => {
  sessionStorage.setItem(CONFIG.USER_INFO_KEY, JSON.stringify({ token, kid } as SessionData))
}
